module.exports = __webpack_public_path__ + "img/ruleBg.7bea75f2.png";